import { z } from 'zod'

export const updateMemberAliasSchema = z.object({
  alias: z.string().min(1).max(100).nullable(),
})

export type UpdateMemberAliasDto = z.infer<typeof updateMemberAliasSchema>
